"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDataAccessors = void 0;
const formula_engine_1 = require("@finley-technologies/formula-engine");
const accessorParams_1 = require("../../accessorParams");
const utils_1 = require("../utils");
const _setConfigVariableString = (params) => {
    const { parameterConfig, variables } = params;
    return `${JSON.stringify(parameterConfig)}${JSON.stringify(variables)}`;
};
const validateDataAccessors = (params) => {
    const errors = [];
    const dataAccessorNameSet = new Set();
    const dataAccessorConfigMap = new Map();
    params.dataAccessors.forEach((dataAccessor) => {
        const { name, method, parameterConfig, variables } = dataAccessor;
        const variableNameSet = new Set(utils_1.SUPPLEMENTAL_QUERY_VARIABLES.map((variable) => variable.name));
        if (name === '') {
            errors.push('Data Accessor name is empty');
            return;
        }
        if (dataAccessorNameSet.has(name)) {
            errors.push(`Duplicate data accessor name [${name}]`);
            return;
        }
        dataAccessorNameSet.add(name);
        // Ensure no method has same "parameterConfig" + "variable" inputs
        const accessorSetup = dataAccessorConfigMap.get(method);
        const currentSetup = _setConfigVariableString({
            parameterConfig,
            variables,
        });
        if (accessorSetup && currentSetup === accessorSetup) {
            errors.push(`Duplicate data accessor setup [method:${method}] [name:${name}]`);
            return;
        }
        dataAccessorConfigMap.set(method, currentSetup);
        for (const variable of variables) {
            if (variableNameSet.has(variable.name)) {
                errors.push(`Duplicate variable input [${variable.name}]`);
                return;
            }
            variableNameSet.add(variable.name);
        }
        if (parameterConfig) {
            for (const [key, config] of Object.entries(parameterConfig)) {
                const { type } = config;
                switch (type) {
                    case 'formula': {
                        const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(config.params.formula, variableNameSet);
                        if (errorMessages.length > 0) {
                            errorMessages.forEach((error) => {
                                errors.push(error);
                            });
                            return;
                        }
                        break;
                    }
                    case 'reportingPeriod':
                        // Nothing to logically validate at this point, config is typesafe,
                        // and checked by typeguard. May need to revisit validation
                        // if config complexity grows
                        break;
                    default:
                        errors.push(`Data accessor error with unsupported config [type:${type}] [accessor:${name}] [parameterConfig:${key}]`);
                        return;
                }
            }
        }
        const accessorParams = (0, accessorParams_1.createAccessorParams)({
            dataAccessor: {
                ...dataAccessor,
                variables: [...utils_1.SUPPLEMENTAL_QUERY_VARIABLES, ...dataAccessor.variables],
            },
        });
        if (!accessorParams.isValid) {
            accessorParams.errors.forEach((error) => errors.push(error));
        }
    });
    return errors;
};
exports.validateDataAccessors = validateDataAccessors;
//# sourceMappingURL=dataAccessorValidate.js.map